export type CodingImageKindKey = 'IMG' | 'IMG_ONOFF' | 'IMG_MULTI';
export const CodingImageKind: Record<CodingImageKindKey, string> = {
  IMG: '이미지',
  IMG_ONOFF: '온오프이미지',
  IMG_MULTI: '여러장이미지',
};
